module.exports = __webpack_public_path__ + "img/perforaciones_3-4_1536.026ab023.webp";